import React from "react";
import Image from "../core/image";
const ProductImage = (props) => {
    const targetImage = props.product.featuredImage?.node ||
        props.product.galleryImages?.nodes[0] ||
        props.product.mediaContent?.nodes[0];
    console.log(targetImage);
    if (!targetImage) {
        return React.createElement(React.Fragment, null);
    }
    const newProps = { targetImage, ...props };
    delete newProps.product;
    return React.createElement(Image, { ...newProps });
};
export default ProductImage;
